var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.515,
    height: 58.784,
    viewBox: "0 0 69.515 58.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48238",
    "data-name": "Group 48238",
    transform: "translate(-5.5 71.125) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94557",
    "data-name": "Path 94557",
    d: "M36.806,69.492a.377.377,0,0,1,0,.546L25.884,87.67a.6.6,0,0,1-1.092-.078l-3.277-7.177a.618.618,0,0,0-.624-.39l-7.88.312a.636.636,0,0,1-.546-1.014l9.05-14.511a.508.508,0,0,1,.7-.156,5.241,5.241,0,0,0,3.823.936l4.057-.546a5.43,5.43,0,0,1,4.915,2.028ZM70.431,80.258l-7.88-.312a.8.8,0,0,0-.624.39L58.65,87.514a.6.6,0,0,1-1.092.078L46.636,69.96a.666.666,0,0,1,0-.546L48.508,67a5.43,5.43,0,0,1,4.915-2.028l4.057.546a5.856,5.856,0,0,0,3.823-.936.508.508,0,0,1,.7.156l9.05,14.511A.719.719,0,0,1,70.431,80.258Z",
    transform: "translate(0 -12.97)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94559",
    "data-name": "Path 94559",
    d: "M14.589,0A14.589,14.589,0,1,1,0,14.589,14.589,14.589,0,0,1,14.589,0Z",
    transform: "translate(27.132 16.188)",
    fill: "#a1a3ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94558",
    "data-name": "Path 94558",
    d: "M66.36,27.032l-2.887-2.184a4.74,4.74,0,0,1-1.794-4.369l.468-3.589a4.742,4.742,0,0,0-5.305-5.305l-3.589.468a4.74,4.74,0,0,1-4.369-1.794L46.7,7.372a4.759,4.759,0,0,0-7.568,0l-2.184,2.887a4.74,4.74,0,0,1-4.369,1.794l-3.589-.468a4.742,4.742,0,0,0-5.305,5.305l.468,3.589a4.74,4.74,0,0,1-1.794,4.369l-2.887,2.184a4.759,4.759,0,0,0,0,7.568l2.887,2.184a4.74,4.74,0,0,1,1.794,4.369l-.468,3.589a4.742,4.742,0,0,0,5.305,5.305l3.589-.468a4.74,4.74,0,0,1,4.369,1.794l2.184,2.887a4.759,4.759,0,0,0,7.568,0l2.184-2.887a4.74,4.74,0,0,1,4.369-1.794l3.589.468a4.742,4.742,0,0,0,5.305-5.305l-.468-3.589a4.74,4.74,0,0,1,1.794-4.369L66.36,34.6A4.853,4.853,0,0,0,66.36,27.032ZM42.877,48.1A17.32,17.32,0,1,1,60.2,30.777,17.33,17.33,0,0,1,42.877,48.1Z",
    transform: "translate(-1.156 0)",
    fill: "#2d2366"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalImage);
export default __webpack_public_path__ + "static/media/MedalImage.53e4c993c83a2a3523ec41f38d2db7aa.svg";
export { ForwardRef as ReactComponent };